// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__TU0W9","tab":"ProcedureTabs_tab__1pWcW"};